/* istanbul ignore file */
import { AssignmentTypeLabels } from 'domain/shared/assignment';
import { useFieldHelper, TextField, FieldProps } from 'framework/ui/field';

const AssignmentTypeField = (props: FieldProps) => {
  const { getValue } = useFieldHelper(props);

  return <TextField {...props} value={AssignmentTypeLabels[getValue()]} />;
};

export default AssignmentTypeField;
